import moment from "moment";
import React from "react";
import { BiTrash } from "react-icons/bi";
import { FaEye, FaPen, FaSearch } from "react-icons/fa";
import { Link } from "react-router-dom";

const TablesList = ({
  title = "",
  tableNameData = [],
  designation,
  tableValueData = {},
  datasShow,
  setPages,
  pages,
  record,
  setRecord,
  setsearchKey,
  setisKeyPress,
  searchKey,
  SearchListApi,
  isSearchField,
  navigateUrl,
  isDeleteIconShow,
  isViewIconShow,
  isEditIconShow,
  onClickDeleteFunc,
  onClickEditFunc,
  showTitle,
}) => {
  return (
    <>
      {/* ----- Body Content ---- */}
      <div className="list-data">
        {showTitle && <h1 className="heading-text mb-4">View All {title}</h1>}
        {/* --- Data filter --- */}
        <div className="data-filters d-flex justify-content-between align-items-center mb-4">
          <div className="page-records d-flex align-items-center">
            <form action="" className="number">
              <select
                className="number-box"
                value={record}
                name="record"
                onChange={(event) => {
                  setRecord(event.target.value);
                  setPages(1);
                }}
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="15">15</option>
              </select>
            </form>
            <h3 className="mb-0 ms-2 d-none d-sm-block">Records Per Page</h3>
          </div>

          {isSearchField && (
            <div className="form search-bar1">
              <input
                type="search"
                className="form-control search-new"
                placeholder={`search ${title} name`}
                aria-label="search"
                aria-describedby="search"
                name="partner_name"
                value={searchKey}
                onKeyDown={(e) => setisKeyPress(false)}
                onChange={(e) => setsearchKey(e.target.value?.trimStart())}
              />
              <button
                className="search-btn fa-solid fa-magnifying-glass"
                type="submit"
                disabled={searchKey?.trimStart() == ""}
                onClick={() => SearchListApi("building")}
              >
                <FaSearch className="m-0 " color="#bebebe" />
              </button>
            </div>
          )}
        </div>
      </div>
      <div className="w-100 table-content">
        <div className="w-100 overflow-auto">
          <table className="w-100">
            <thead>
              <tr>
                {tableNameData?.map((tdata, i) => (
                  <th key={i}>{tdata}</th>
                ))}
              </tr>
            </thead>

            <tbody>
              {datasShow?.length > 0 ? (
                datasShow?.map((items, i) => {
                  return (
                    <tr key={i} className={`border-b`}>
                      <td className="">
                        {pages > 1 ? record * (pages - 1) + i + 1 : i + 1}
                      </td>

                      {tableValueData?.value.map((it, index) => (
                        <>
                          <td
                            style={
                              tableValueData?.value[index] == "receiver_status"
                                ? {
                                    color:
                                      items[tableValueData?.value[index]] ==
                                      "In Progress"
                                        ? "orange"
                                        : items[tableValueData?.value[index]] ==
                                          "Pending"
                                        ? "red"
                                        : "green",
                                  }
                                : tableValueData?.value[index] == "status"
                                ? {
                                    color: items[tableValueData?.value[index]]
                                      ? "green"
                                      : "red",
                                  }
                                : { color: "" }
                            }
                            className={
                              tableValueData?.design[index] == "c" &&
                              "text-center"
                            }
                            key={it}
                          >
                            {tableValueData?.value[index] ==
                            "AssignBuildings" ? (
                              items[tableValueData?.value[index]]?.length
                            ) : tableValueData?.value[index] ==
                              "account_number_all" ? (
                              items[tableValueData?.value[index]]?.map((ac,inp) => (
                                <>{ac} {items[tableValueData?.value[index]]?.length !== (inp +1) && ","} </>
                              ))
                            ) : tableValueData?.value[index] == "status" ? (
                              items[tableValueData?.value[index]] == true ? (
                                "Active"
                              ) : (
                                "Inactive"
                              )
                            ) : tableValueData?.value[index] == "createdAt" ||
                              tableValueData?.value[index] ==
                                "lease_start_date" ||
                              tableValueData?.value[index] == "deadline" ||
                              tableValueData?.value[index] ==
                                "lease_end_date" ? (
                              moment(
                                items[tableValueData?.value[index]]
                              ).format("L")
                            ) : tableValueData?.value[index] ===
                              "managerlist" ? (
                              items[tableValueData?.value[index]]?.map((m) => (
                                <p>{m?.PersonalDetail?.email}</p>
                              ))
                            ) : tableValueData?.value[index] === "taskkk" ? (
                              0
                            ) : tableValueData?.value[index] ===
                              "requestReceiversList" ? (
                              items[tableValueData?.value[index]]?.map((t) => (
                                <span>
                                  {`${t?.User?.first_name} ${t?.User?.middle_name}  ${t?.User?.last_name}`}{" "}
                                  <br />{" "}
                                </span>
                              ))
                            ) : tableValueData?.value[index] ===
                                "receiver_status" &&
                              designation == "Tenant" &&
                              items[tableValueData?.value[index]] ==
                                "Waiting for Aprroval" ? (
                              <select
                                // onChange={(e) => {
                                //   StatusFunc(e, items.id);
                                // }}
                                style={{ color: "green" }}
                              >
                                <option value="">Choose status</option>
                                <option value="Completed">Completed</option>
                                <option value="Pending">Pending</option>
                              </select>
                            ) : items[tableValueData?.value[index]]?.length ? (
                              items[tableValueData?.value[index]].slice(0, 80)
                            ) : (
                              items[tableValueData?.value[index]]
                            )}
                          </td>
                        </>
                      ))}

                      <td className="text-center">
                        <ul className="table-icon d-flex">
                          {isViewIconShow && (
                            <li>
                              <Link
                                to={
                                  designation == "Owner" ||
                                  designation == "Partner"
                                    ? `/${navigateUrl}-details/${items.id}`
                                    : `/${designation.toLowerCase()}/${navigateUrl}-details/${
                                        items.id
                                      }`
                                }
                              >
                                <FaEye
                                  className="view-icon  me-2"
                                  color="black"
                                />
                              </Link>
                            </li>
                          )}
                          {isDeleteIconShow && (
                            <li>
                              <button onClick={() => onClickDeleteFunc(items)}>
                                <BiTrash
                                  className="view-icon me-2"
                                  color="black"
                                />
                              </button>
                            </li>
                          )}
                          {isEditIconShow && (
                            <li>
                              <button onClick={() => onClickEditFunc(items)}>
                                <FaPen className="" color="black" />
                              </button>
                            </li>
                          )}
                        </ul>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="9" className="text-center">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default TablesList;
